import React, { PropsWithChildren, useEffect } from "react";
import Image from "next/image";
import { imageLoaderForStaticImages } from "../../context/utils";
import { useAppContext } from "../../context/siteMapContext";
interface IModalProps extends PropsWithChildren {
  isOpen?: boolean;
  handleClose: () => void;
}

export const setBodyOverflow = (value: string): void => {
  document.body.style.overflow = value;
};

const Modal: React.FC<IModalProps> = ({
  children,
  isOpen = false,
  handleClose,
}) => {

  const { highContrastOn } = useAppContext();

  useEffect(() => {
    if (isOpen) {
      setBodyOverflow("hidden");
    } else {
      setBodyOverflow("unset");
    }
    return () => {
      setBodyOverflow("unset");
    };
  }, [isOpen]);

  const onClose = () => {
    setBodyOverflow("unset");
    handleClose();
  };

  return (
    <>
      {isOpen && (
        <div className='absolute z-modal h-[100vh] w-[100vw] inset-0 flex items-center justify-center'>
          <div
            className={`absolute z-modal opacity-80 h-full w-full ${highContrastOn ? 'bg-modal-overlay-hc' : 'bg-modal-overlay'}`}
            onClick={handleClose}
          />
          <div className='absolute margin-auto z-modal-content'>
            {children}
            <div className='absolute top-[6px] right-[6px] xl:top-[24px] xl:right-[24px] h-20 w-20 rounded-full bg-white'>
              <Image
                loader={imageLoaderForStaticImages}
                alt='Rendkívüli hír bezárása'
                src={"/common/Icon_close.svg"}
                layout='fill'
                objectFit='cover'
                width={60}
                height={60}
                className='cursor-pointer'
                onClick={onClose}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Modal;
